<template>
    <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90 90">
        <defs>
        </defs>
        <path class="cls-1" d="m36.23,60.36c-13.53,0-24.54-11.01-24.54-24.54s11.01-24.54,24.54-24.54,24.54,11.01,24.54,24.54-11.01,24.54-24.54,24.54Zm0-42.83c-10.08,0-18.28,8.2-18.28,18.28s8.2,18.29,18.28,18.29,18.28-8.2,18.28-18.29-8.2-18.28-18.28-18.28Z"/>
        <path class="cls-1" d="m75.19,78.72c-.8,0-1.6-.31-2.21-.92l-23.35-23.35c-1.22-1.22-1.22-3.2,0-4.42,1.22-1.22,3.2-1.22,4.42,0l23.35,23.35c1.22,1.22,1.22,3.2,0,4.42-.61.61-1.41.92-2.21.92Z"/>
        <path class="cls-2" d="m37.26,51.39c-8.98,0-16.28-7.3-16.28-16.28,0-.58.47-1.04,1.04-1.04s1.04.47,1.04,1.04c0,7.83,6.37,14.2,14.2,14.2.58,0,1.04.47,1.04,1.04s-.47,1.04-1.04,1.04Z"/>
    </svg>
</template>

<script>
export default {
    name: "DeepDiveIcon",
}
</script>

<style scoped>
  .cls-1 {
    fill: #0f5b71;
  }
  .cls-2 {
    fill: #59c5c7;
  }
</style>
